module.exports = __webpack_public_path__ + "9150254b8f29d16158bd917a34447ef4.png";